module.exports = __webpack_public_path__ + "img/logo-branca.22c95c18.png";